import { configService } from "@/settings/api-url";
const actions = {
  async action_postCouponsAtivate({ dispatch, commit }, data) {
    try {
      const res = await configService("coupons/activate", {
        method: "POST",
        data,
      });
      dispatch("action_getCart");
      commit("TEMPORAL_COUPON", data.coupon.code);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_postCouponsDelete({ dispatch, commit }, data) {
    try {
      const res = await configService("coupons/deactivate", {
        method: "POST",
        data,
      });
      dispatch("action_getCart");
      commit("TEMPORAL_COUPON", "");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_postOrder({ commit }, data) {
    try {
      const res = await configService(`orders`, {
        method: "POST",
        data,
      });
      const res_order = res.data;
      if (res_order.pse_charge) {
        commit("PSE_ORDER", res.data);
      }
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getPseStatus({ commit }, payload) {
    try {
      const res = await configService(`pse_payment_status?transaction_id=${payload}`);
      commit("PSE_STATUS", res.data.transaction);
      commit("PSE_ORDER", res.data.order);
      return res.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_setPseStatus({}, data) {
    try {
      const res = await configService(`set_wompi_pse_response`, {
        method: "POST",
        data,
      });
      return res.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getPaymentLinkStatus({ commit }, payload) {
    try {
      const res = await configService(`link_payment_status?transaction_id=${payload}`);
      commit("PAYMENT_LINK_STATUS", res.data.transaction);
      commit("PSE_ORDER", res.data.order);
      return res.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
